import AboutDialog from './AboutDialog'

export default AboutDialog
